import { render, staticRenderFns } from "./DataConfigurationColumnMappingPanel.vue?vue&type=template&id=484aad24&scoped=true"
import script from "./DataConfigurationColumnMappingPanel.vue?vue&type=script&lang=js"
export * from "./DataConfigurationColumnMappingPanel.vue?vue&type=script&lang=js"
import style0 from "./DataConfigurationColumnMappingPanel.scss?vue&type=style&index=0&id=484aad24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484aad24",
  null
  
)

export default component.exports